import { ErrorBoundary } from "@sentry/react";
import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { setPageName } from "../../../actions";
import { notifyGoogleAccountAssociated } from "../../../api";
import "../../../assets/styles/pages/ignitepdfpage.scss";
import { ErrorMsg } from "../../../components/AppMessages";
import { IframeLayout } from "../../../components/Layouts";
import { IframePageContent } from "../../../components/PageContent";
import { TORCH_RED, WHITE } from "../../../constants";
import { LookStudioEmbeddedLinks } from "../../../constants/globalMSSalesConstants";
import { ThemeContext } from "../../../context";

const IgniteNissanPdf = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);

  const dashboard = new URLSearchParams(location.search).get("dashboard") ?? "global_ms_sales";

  useEffect(() => {
    dispatch(setPageName(""));
  }, [dispatch]);

  const handleSubmitAccess = useCallback(() => {
    notifyGoogleAccountAssociated(dashboard)
      .then((response) => {
        if (response?.error) {
          toast.error("Failed to update your request, please try again later");
        } else {
          toast.success("Request for access has been received");
        }
      })
      .catch(() => {
        toast.error("Failed to update your request, please try again later");
      });
  }, [dashboard]);

  const handleClick = () => {
    history.goBack();
  };

  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {/* Both children below need to land in .dashboard's single "body" grid cell (main.scss),
            stacked vertically - this wrapper is the one actual grid item there (see
            ignitepdfpage.scss), so IframePageContent's own #container (still carrying its usual
            grid-area: body from pageContainer.scss) just becomes an ordinary nested block instead
            of a second, overlapping grid item in the same cell. */}
        <div className="ignite_pdf_page_body">
          <div
            className="main_dashboard_ignitepdf"
            style={{
              backgroundColor: theme === "light" ? "#e7ecf0" : "#1a1a1a",
            }}
          >
            <div className="section">
              <div onClick={handleClick} className="back_button" style={{ color: theme === "light" ? TORCH_RED : WHITE }}>
                &lt;
                <span className="back_text">Back</span>
              </div>
              <div className="button_container">
                {/* No inline color override - submitrequestBtn's own white text (buttons.scss) already
                    reads fine against its now-red background in both themes, matching TrimMixReport.tsx's
                    own plain usage of this same button. */}
                <button className="submitrequestBtn" onClick={handleSubmitAccess}>
                  Let us know if you already have an associated Google Account to gain access
                </button>
              </div>
            </div>
          </div>
          <IframePageContent frameId="global_ms_sales_ignitepdf" iframeUrl={LookStudioEmbeddedLinks.IgniteNissanPdf} />
        </div>
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default IgniteNissanPdf;
